import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AppUseSelector } from '../../redux/hooks'
import NotificationBox from '../../containers/form/NotificationBox'
import { DEFAULT_LANGUAGE, normalizeLanguage } from '../../i18n/languages'
import { saveLanguageSettings } from '../../i18n/profileLanguage'
import { SettingsOption, SettingsSection } from './SettingsSection'

/**
 * "Also show English meanings": the word panel adds the English meaning under the one in the
 * learner's language. Hidden for English, where there is nothing to add.
 */
const MeaningsSection = ({ id }: { id?: string }) => {
  const { t, i18n } = useTranslation()
  const showEnglish = AppUseSelector((state: any) => !!state.user?.credentials?.customFields?.show_english_meanings)
  const [isUpdating, setIsUpdating] = useState(false)
  const [notify, setNotify] = useState({ label: '', isError: false })

  const clearNotify = () => setNotify({ label: '', isError: false })

  if (normalizeLanguage(i18n.language) === DEFAULT_LANGUAGE) return null

  const handleToggle = async () => {
    if (isUpdating) return
    clearNotify()
    setIsUpdating(true)
    try {
      await saveLanguageSettings({ show_english_meanings: !showEnglish })
      setNotify({ label: t('meaningsSettings.saved'), isError: false })
    } catch {
      setNotify({ label: t('meaningsSettings.saveError'), isError: true })
    } finally {
      setIsUpdating(false)
    }
  }

  return (
    <SettingsSection id={id} title={t('meaningsSettings.title')}>
      <NotificationBox clearNotify={clearNotify} {...notify} />
      <SettingsOption
        type='checkbox'
        label={t('meaningsSettings.showEnglish')}
        description={t('meaningsSettings.showEnglishDescription')}
        checked={showEnglish}
        disabled={isUpdating}
        onChange={handleToggle}
      />
    </SettingsSection>
  )
}

export default MeaningsSection
